import Image from 'next/image'
import React from 'react'

export interface ISection {
    textPosition: 'right' | 'left' | string
    textContent: string
    image: string
    subTitle: string
    subTitleColor: string
    title?: string | undefined
    rounded?: boolean
    backgroundColor?: string | undefined
}

interface ISectionInfoPagesProps {
    section: ISection
}

/** Bloco de texto e imagem da página de sustentabilidade, com a imagem à esquerda ou à direita do texto. */
export const SectionInfoPages: React.FC<ISectionInfoPagesProps> = ({ section }) => {
    if (section.textPosition === 'right') {
        if (section.rounded) {
            return (
                <div className="2xl:px-[500px] px-[300px] max-lg:px-8 flex flex-row max-md:flex-col items-center justify-between gap-12">
                    <Image
                        src={section.image}
                        height={106}
                        width={400}
                        alt=""
                        style={{ backgroundColor: section.backgroundColor }}
                        className="max-md:hidden rounded-full p-2"
                    />
                    <div className="md:w-[500px]">
                        <h1 className="uppercase text-accent font-bold text-xs">{section.title}</h1>
                        <h1 className="font-semibold text-lg mb-5" style={{ color: section.subTitleColor }}>
                            {section.subTitle}
                        </h1>
                        <p className="text-left text-xs leading-relaxed ">{section.textContent}</p>
                    </div>
                    <Image
                        src={section.image}
                        height={106}
                        width={400}
                        alt=""
                        style={{ backgroundColor: section.backgroundColor }}
                        className="md:hidden rounded-3xl p-2"
                    />
                </div>
            )
        } else {
            return (
                <div className="2xl:px-[500px] px-[300px] max-lg:px-8 flex flex-row max-md:flex-col items-center justify-between gap-12">
                    <Image src={section.image} height={106} width={400} alt="" className="max-md:hidden " />
                    <div className="md:w-[500px]">
                        <h1 className="uppercase text-accent font-bold text-xs">{section.title}</h1>
                        <h1 className="font-semibold text-lg mb-5" style={{ color: section.subTitleColor }}>
                            {section.subTitle}
                        </h1>
                        <p className="text-left text-xs leading-relaxed ">{section.textContent}</p>
                    </div>
                    <Image
                        src={section.image}
                        height={106}
                        width={400}
                        alt=""
                        style={{ backgroundColor: section.backgroundColor }}
                        className="md:hidden rounded-3xl p-2"
                    />
                </div>
            )
        }
    }

    if (section.textPosition === 'left')
        return (
            <div className="2xl:px-[500px] px-[300px] max-lg:px-8 flex flex-row max-md:flex-col items-center justify-between gap-12">
                <div className="md:w-[400px]">
                    <h1 className="uppercase text-accent font-bold text-xs">{section.title}</h1>
                    <h1 className=" font-semibold text-lg mb-5" style={{ color: section.subTitleColor }}>
                        {section.subTitle}
                    </h1>
                    <p className="text-left text-xs leading-relaxed ">{section.textContent}</p>
                </div>
                <Image
                    src={section.image}
                    height={106}
                    width={500}
                    alt=""
                    style={{ backgroundColor: section.backgroundColor }}
                    className="rounded-3xl p-2 "
                />
            </div>
        )
    return null
}
